import { render, staticRenderFns } from "./ChatScalable.vue?vue&type=template&id=92f578c4"
import script from "./ChatScalable.vue?vue&type=script&lang=js"
export * from "./ChatScalable.vue?vue&type=script&lang=js"
import style0 from "./ChatScalable.vue?vue&type=style&index=0&id=92f578c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports